import { call, put, takeEvery } from 'redux-saga/effects';
import { getGroupOptionsPermissions } from '../../requests/get_permissions_request';
import { getGroupOptionsPermissionsSuccess, getGroupOptionsPermissionsFailure } from '../actions/get_group_options_permissions.actions';
import { GET_GROUP_OPTIONS_PERMISSIONS_REQUEST } from '../constants/get_group_data.constants';
import { message_error } from '../../../../../components/Message';

function* getGroupOptionsPermissionsRequest({ groupId, entity, moduleURL }) {
    if (entity !== 'model') {
        const { result, options, error } = yield call(getGroupOptionsPermissions, groupId, entity, moduleURL);
        if (result) {
            yield put(getGroupOptionsPermissionsSuccess(options));
        } else {
            yield put(getGroupOptionsPermissionsFailure(error));
            message_error(error);
        }
    }
}

export default function* getGroupOptionsPermissionsSaga() {
    yield takeEvery(GET_GROUP_OPTIONS_PERMISSIONS_REQUEST, getGroupOptionsPermissionsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/get_group_options_permissions.saga.js